import clsx from "clsx";
import React, { ReactNode, Suspense } from "react";
import { type MarketingHeaderVariant } from "@/constants/redesign";
import { MarketingFooter } from "@/components/redesign/MarketingFooter";
import Footer from "./Footer";
import Header from "./Header";

interface ContainerProps {
  children: ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  footerDemoBtnPushToTop?: boolean;
  headerVariant?: MarketingHeaderVariant;
}

const Container: React.FC<ContainerProps> = ({
  children,
  showHeader,
  showFooter,
  footerDemoBtnPushToTop,
  headerVariant = "default",
}) => {
  const isRedesign = headerVariant === "redesign";

  return (
    <div
      data-redesign-surface={isRedesign ? "" : undefined}
      className={clsx(
        "flex flex-col min-h-screen",
        isRedesign && "bg-marketing-surface",
      )}
    >
      {(showHeader || showHeader === undefined) && (
        <Header variant={headerVariant} />
      )}
      <main className={clsx("overflow-x-clip", "grow")}>{children}</main>
      {(showFooter || showFooter === undefined) &&
        (isRedesign ? (
          <Suspense fallback={null}>
            <MarketingFooter />
          </Suspense>
        ) : (
          <Suspense fallback={null}>
            <Footer footerDemoBtnPushToTop={footerDemoBtnPushToTop} />
          </Suspense>
        ))}
    </div>
  );
};

export default Container;
